<template>
  <div   class="page-index">
    <div>
      <div class="list-block media-list">
        <ul>
          <!--<li>-->
            <!--<a @click="clickMerchandise" class="item-link item-content">-->
              <!--<div class="item-inner" style="padding-bottom: 0rem">-->
                <!--<div class="item-title-row">-->
                  <!--<div class="item-title"><span>慢病毒</span> <span>过表达</span> <span>Ubi C-3FLAG</span> <span>EGFP</span> <span>puromycin</span></div>-->
                  <!--<div class="item-after" style="font-size: xx-small">  <label class="label-checkbox checkbox-el ">-->
                    <!--<div class="item-media small-checkbox small-filter-el"><div class="span-text" style="font-size: xx-small">广谱启动子</div></div>-->
                  <!--</label>-->
                    <!--<label class="label-checkbox " >-->
                      <!--<div class="item-media small-checkbox  small-filter-el"><div class="span-text">human</div></div>-->
                    <!--</label>-->
                    <!--<label class="label-checkbox  ">-->
                      <!--<div class="item-media small-checkbox  small-filter-el"><div class="span-text">stat1</div></div>-->
                    <!--</label> </div>-->
                <!--</div>-->
                <!--<div class="item-text" ><div style="height: 1.6rem">-->
                  <!--<div style="float:left;"><span style="color: #1D66E1;font-size: .7rem">$12000</span> <span style="margin-left: .3rem"><button class="button workdays" >周期20个工作日</button></span></div>-->
                  <!--<div style="float: right;font-size: .5rem">-->
                    <!--<span class="sub-span">现货</span>-->
                    <!--<span class="sub-span">减券</span>-->
                  <!--</div>-->
                <!--</div></div>-->
              <!--</div>-->
            <!--</a>-->
          <!--</li>-->
          <li v-for="pro in merchListWithoutCustomized10">
            <a @click="clickMerchandise(pro)" class="item-link item-content">
              <div class="item-inner" style="padding-bottom: 0rem">
                <div class="item-title-row" v-if="filteredShowPromotions(pro) && filteredShowPromotions(pro).length > 0">
                    <span>
                      <span style="font-size: 0.5rem;color: red;padding: 0.1rem;">{{filteredShowPromotions(pro)[0].name}}</span>
                    </span>
                  <!--促销开始小图标-->
                  <div class="item-after" v-if="filteredShowPromotions(pro)[0].type === 6">
                    <img src="/emktResources/resocurces/img/promotion/miaosha_mobile.png" alt="秒杀进行/预告" height="30px" v-if="secFlag!==2">
                  </div>
                </div>
                <div class="item-title"><span v-for="title in pro._titleList" style="margin-right: .3rem"><span v-if="title.columnName === 'TVInfo'">{{title.valueText.TLNo}}</span><span v-else>{{title.valueText}}</span></span></div>
                <div class="item-subtitle" style="font-size: xx-small">
                  <label class="label-checkbox checkbox-el " v-for="abstract in pro._abstractList">
                    <div class="item-media small-checkbox small-filter-el"><div class="span-text radiuscolor" style="font-size: xx-small;margin-right:.3rem">  <span v-if="abstract.columnName === 'TVInfo'">{{abstract.valueText.TLNo}}</span><span v-else>{{abstract.valueText}}</span></div></div>
                  </label>
                  <label class="label-checkbox checkbox-el " v-for="subTitle in pro._subTitleList">
                    <div class="item-media small-checkbox small-filter-el"><div class="span-text radiuscolor" style="font-size: xx-small;margin-right:.3rem">{{subTitle.valueText}}</div></div>
                  </label>
                </div>
                <div class="item-text" ><div style="height: 1.6rem">
                  <div style="float:left;"><span style="color: #1D66E1;font-size: .7rem" v-if="sessionInfo.customerInfo && sessionInfo.customerInfo.ssoFlag === 1">¥{{pro.priceMax}}</span>
                    <span style="color: #1D66E1;font-size: .7rem" v-else>¥{{pro.priceMin}}</span> <span style="margin-left: .3rem"><button class="button workdays" >周期{{pro.cycle}}工作日</button></span></div>
                  <div style="float: right;font-size: .5rem">
                    <span class="sub-span">现货</span>
                  </div>
                </div></div>
                <div style="font-size: .4rem;margin-bottom: .5rem;color: rgb(29, 102, 225)" v-if="pro._attributes.Product_Master  && pro._attributes.Product_Master.value !=='Customize'">{{pro._attributes.Product_Master.value}}</div>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
  import $ from 'jquery'
  import emkt from '../../../emkt'
  import {mapState, mapMutations, mapGetters} from 'vuex'
  export default {
    // 在 props 中声明获取父组件的数据通过 message 传过来
    props: ['merchList', 'description', 'showFilterBar', 'showFilterBarForKit', 'isFromSearch', 'proo', 'channel'],
    data () {
      return {
        baseurl: '/emktResources/resocurces/img/merchandise/',
        total: 0
      }
    },
    methods: {
      ...mapMutations([
        'ADD_CART_LIST', 'MERCHDISEGROUP_UPDATE'
      ]),
      addCartListForRecom (pro) {
        this.ADD_CART_LIST(pro)
        $.toast('加入购物车成功！')
      },
      setdatas (pro) {
        if (this.isFromSearch) {
          emkt.customerBehaviours.searchresults.click = {'time': Date.parse(new Date()), 'target': pro.merchandiseId, 'type': emkt.customerBehaviourType.clickMer}
        }
        var _self = this
        _self.MERCHDISEGROUP_UPDATE(pro.compositions)
        this.$router.push({path: '/promotion/Compositions'})
      },
      openshaxuan () {
        // $.openPanel('#panel-right-demo')
      },
      getbpromotions (merchdise) {
        if (merchdise.bpromotions) {
          var bpromotions = merchdise.bpromotions
          var r = []
          var t = []
          for (var m = 0; m < bpromotions.length; m++) {
            if (t.indexOf(bpromotions[m].type) === -1) {
              r.push(bpromotions[m])
              t.push(bpromotions[m].type)
              // console.log(m + ' ' + bpromotions[m].type)
            }
          }
          return r
        }
      },
      clickMerchandise (pro) {
        var id = ''
        if (pro.categoryId === 20) {
          id = pro.findId
        } else {
          id = pro.merchandiseId
        }
        if (this.isFromSearch) {
          emkt.customerBehaviours.searchresults.click = {'time': Date.parse(new Date()), 'target': id, 'type': emkt.customerBehaviourType.clickMer}
        }
        if (this.proo) {
          this.$router.push({name: 'finderMerchandises', query: {id: id, categoryId: pro.categoryId}, params: {pro: this.proo}})
        } else if (this.channel) {
          this.$router.push({name: 'finderMerchandises', query: {id: id, categoryId: pro.categoryId}, params: {channel: this.channel}})
        } else {
          this.$router.push({name: 'finderMerchandises', query: {id: id, categoryId: pro.categoryId}})
        }
      },
      filteredShowPromotions (merchandise) {
        if (merchandise.promotions && merchandise.promotions.length > 0) {
          return merchandise.promotions.filter(pro => pro.requiredCustomers === 0 && pro.description && pro.type !== 0)
        }
        if (merchandise.bpromotions && merchandise.bpromotions.length > 0) {
          return merchandise.bpromotions.filter(pro => pro.requiredCustomers === 0 && pro.description && pro.type !== 0)
        }
        return []
      }
    },
    computed: {
      ...mapState([
        'queryTotal', 'sessionInfo', 'secInfo'
      ]),
      ...mapGetters([
        'secFlag'
      ]),
      merchs: function () {
        var newmerchList = []
        if (!this.merchList) {
          return newmerchList
        }
        newmerchList = this.merchList
//        for (var i = 0; i < newmerchList.length; i++) {
//          var tags = []
//          var merchandiseMeta = emkt.getEmktMetaData()
//          var tagsmap = merchandiseMeta.tagsMap
//          for (var j = 0; j < newmerchList[i].tagIds.length; j++) {
//            tags.push(tagsmap[newmerchList[i].tagIds[j]].tagLabel)
//          }
//          newmerchList.tags = tags
//          var bpromotions = newmerchList[i].bpromotions
//          var r = []
//          var t = []
//          for (var m = 0; m < bpromotions.length; m++) {
//            if (t.indexOf(bpromotions[m].type) === -1) {
//              r.push(bpromotions[m])
//              t.push(bpromotions[m].type)
//              console.log(m + ' ' + bpromotions[m].type)
//            }
//          }
//          newmerchList[i].bpromotions = r
//        }
        this.total = newmerchList.length
        return newmerchList
      },
      showFilterBarFlag () {
        let flag = true
        let src = this.$route.name
        if (src === 'home') {
          flag = false
        }
        if (!this.showFilterBar) {
          flag = false
        }
        return flag
      },
      secPromotionRatio () {
        let ratio = String(100 - this.secInfo.seckilltRatio * 100)
        ratio = (ratio[1] === '0') ? ratio[0] : ratio
        return ratio
      },
      merchListWithoutCustomized10 () {
        if (this.merchList && this.merchList.length > 0) {
          return this.merchList.filter(product => product.categoryId !== 10)
        }
        return []
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



  .checkbox-el {
    display: inline-block;
    text-align: left;
  }


  /*搜索内容区*/
  .item-inner {
    display: block;
  }
  .item-title {
    font-size: 0.6rem;
  }
  item-text {
    margin-top: 0.3rem;
  }
  .sub-span {
    font-size: 0.5rem;
    color: white;
    background-color: #00469A;padding: 0.1rem;border-radius:.25rem;
  }

  .workdays {
    display: inherit;font-size: .5rem;line-height: 0px;height: 0.85rem;border-radius:.45rem;border:1px solid #1D66E1;color:#1D66E1
  }
  .radiuscolor {
    background-color: #E6E6E6;border-radius:.25rem;
  }
</style>



// WEBPACK FOOTER //
// NewMerchandiseListB.vue?46f2f35f